{
    "Section_Header": "Verzenden naar Opties:",
    "Section_SubHeader": "Rapporten verzenden naar:",
    "Validation_Valid_Domain_Name": "E-mailadres moet geldig zijn",
    "Validation_Valid_Same_As_User": "E-mailadres moet binnen hetzelfde domein vallen als dat van de huidige gebruiker",
    "Validation_Valid_Non_Blacklisted_Email": "E-mail mag zich niet binnen een domein op de zwarte lijst bevinden",
    "Validation_Valid_Max_Custom_Domains": "U kunt maximaal {} aangepaste e-mailadressen toevoegen",
    "Validation_Valid_Max_Entries": "Je kunt niet meer dan {} e-mailadressen hebben",
    "NAME": "ReportSchedulingEmails"
}